// https://emailregex.com/
const EMAIL_PATTERN = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const isValidEmail = (email) => (
  typeof email === 'string' && email.length < 128 && EMAIL_PATTERN.test(email)
);
const isValidMessage = (message) => typeof message === 'string' && message.length > 10;

export {
  isValidEmail,
  isValidMessage,
};
